import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ReportingApiBaseUrlResolverService } from './reporting-api-base-url-resolver.service';
import { REPORTING_API_REQUEST } from './reporting-api.service';

@Injectable()
export class ReportingApiBaseUrlInterceptor implements HttpInterceptor {
  constructor(private readonly reportingApiBaseUrlResolverService: ReportingApiBaseUrlResolverService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.context.get(REPORTING_API_REQUEST)) {
      return next.handle(request);
    }

    return from(this.reportingApiBaseUrlResolverService.resolveBaseUrl()).pipe(
      mergeMap(baseUrl => {
        const resolvedUrl = this.reportingApiBaseUrlResolverService.getReportingApiUrl(baseUrl, request.url);
        console.info('[Reporting API][Request]', {
          method: request.method,
          path: request.url,
          resolvedUrl,
          resolution: this.reportingApiBaseUrlResolverService.getLastResolutionDetails(),
        });
        return next.handle(request.clone({ url: resolvedUrl }));
      }),
    );
  }
}
